import {
  getRewardPath,
  getRewardPost,
  getUserRewardPath,
  getRewardListAll,
} from "../constants/apiRoutes";

import apiService from "../utils/configAxios";
import { rewardActions } from "../reducers/reward";
import { toast } from "react-toastify";
import { t } from "i18next";

export const fetchRewardList = (id) => {
  return (dispatch) => {
    return apiService
      .get(getRewardPath(id))
      .then((response) => {
        dispatch(rewardActions.fetchRewardList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchUserRewardList = (status) => {
  let statusName;
  switch (status) {
    case 0:
      statusName = "PENDING";
      break;
    case 1:
      statusName = "REJECTED";
      break;
    case 2:
      statusName = "APPROVED";
      break;
    default:
      statusName = "PENDING";
  }

  return (dispatch) => {
    return apiService
      .get(getUserRewardPath())
      .then((response) => {
        dispatch(rewardActions.fetchUserRewardList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchRewardPost = (data) => {
  return (dispatch) => {
    return apiService
      .post(getRewardPost(), data)
      .then((response) => {
        toast.success(t("rewardInfo.claim.success"), {
          theme: "colored",
        });
      })
      .catch((err) => {
        handleError(err);
      });
  };
};
export const fetchRewardListAll = (id) => {
  return (dispatch) => {
    return apiService
      .get(getRewardListAll())
      .then((response) => {
        dispatch(rewardActions.fetchRewardListAll(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

const handleError = (err) => {
  let errorMessage = err.response ? err.response.data.message : err;
  if (!err.response) {
    toast.error(t("security.error.refresh"), { theme: "colored" });
  }
  toast.error(errorMessage, { theme: "colored" });
};
